// @flow weak
import React, { Component } from "react";
import { connect } from "react-redux";
import { UserActions } from "../reducers/user/index";
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Panel,
  PanelBody,
  Row,
  Tab,
  Button,
  Table,
} from "@sketchpixy/rubix";
import PropTypes from "prop-types";
import {
  ADMIN_ROLE,
  APPROVED_USER,
  DENIED_USER,
  INITIAL_PAGE_NUMBER,
  NOT_APPROVED_USER,
  getProperRoleName,
} from "../utils";
import {
  DEFAULT_DATE_TIME_FORMAT,
  APPROVED,
  PENDING,
  NOT_REQUIRED,
  INVITED,
  NOT_PROVIDED,
  DEFAULT_USER_IMAGE,
} from "../utils/index";
import _ from "lodash";
import UserListItem from "./UserListItem";
import NotificationSystem from "react-notification-system";
import AddNewUser from "../components/addNewUser";
import UpdateUserPassword from "../components/updateUserPassword";

class UserListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRoleType: ADMIN_ROLE,
      searchText: undefined,
      approvalStatus: undefined,
      allUsers: [],
      showAddNewPopup: false,
      showUpdatePassPopup: false,
      selectedUser: {},
      originalUserList: [],
      searchTerm: "",
      usersByPage: [],
      pageNumber: 1
    };
  }

  componentDidMount() {
    this.fetchListing(this.props);
    this._notificationSystem = this.refs.notificationSystem;
  }
  _addNotification = (message, type, title) => {
    this._notificationSystem.clearNotifications();
    this._notificationSystem.addNotification({
      message,
      title: title,
      level: type,
      position: "br",
      autoDismiss: 5,
    });
  };

  componentWillReceiveProps(newProps = []) {
    const { allUsers } = this.state;
    const { error, fetching } = newProps;

    const sortedUsers = _.cloneDeep(newProps.allUsers).sort(
      (user, nextUser) => {
        if(user.fullName !== null && nextUser.fullName !== null) {
          if (user.fullName.toLowerCase() < nextUser.fullName.toLowerCase()) {
            return -1;
          } else if (
            user.fullName.toLowerCase() > nextUser.fullName.toLowerCase()
          ) {
            return 1;
          }
        }
        return 0;
      }
    );

    const usersByPage = sortedUsers.slice((newProps.pageNumber-1) * 10, newProps.pageNumber * 10)

    if (!fetching) {
      if (!_.isEqual(allUsers, newProps.allUsers)) {
        this.setState({
          allUsers: usersByPage,
          usersByPage: usersByPage,
          originalUserList: sortedUsers,
        });
      }
      if (error) {
        this.setState({
          allUsers: [],
        });
      }
    }

    const { userInfo: { role: newPropsRole } = {}, filters = undefined } =
      newProps;
    const { userInfo: { role: existingPropsRole } = {} } = this.props;
    const {
      approvalStatus = undefined,
      searchText = undefined,
      selectedRoleType,
    } = this.state;
    const newFilters = { ...filters, status: approvalStatus };

    if (newPropsRole && newPropsRole !== existingPropsRole) {
      this.props.getAllUsersInfo(
        selectedRoleType,
        INITIAL_PAGE_NUMBER,
        searchText,
        newFilters
      );
    }
  }

  searchUser = ({ target: { value: searchText } }) => {
    this.setState(
      {
        searchText,
      },
      () => {
        this.fetchListing(this.props);
      }
    );
  };

  selectApprovalStatus = ({ target: { value } }) => {
    this.setState(
      {
        approvalStatus: value === "undefined" ? undefined : value,
      },
      () => {
        this.fetchListing(this.props);
      }
    );
  };

  fetchListing = (props) => {
    const { filters = undefined } = props;
    const {
      approvalStatus = undefined,
      searchText = undefined,
      selectedRoleType,
    } = this.state;
    const newFilters = { ...filters, status: approvalStatus };

    this.props.getAllUsersInfo(
      selectedRoleType,
      INITIAL_PAGE_NUMBER,
      searchText,
      newFilters
    );
  };
  showPopOver = (e, user) => {
    e.stopPropagation();
    const { allUsers } = this.state;
    for (let usr of allUsers) {
      if (usr.id === user.id) {
        usr.popShow = !usr.popShow;
      } else {
        usr.popShow = false;
      }
    }
    this.setState({ allUsers });
  };
  closeAllPopovers = () => {
    const { allUsers } = this.state;
    for (let usr of allUsers) {
      usr.popShow = false;
    }
    this.setState({ allUsers });
  };

  addNewUserModal = (user) => {
    this.setState({ showAddNewPopup: true, selectedUser: user });
  };

  updateUserPasswordModal = (user) => {
    this.setState({ showUpdatePassPopup: true, selectedUser: user });
  };
  deleteUser = (id) => {
    if (window.confirm("Are you sure to delete?")) {
      let { history } = this.props;
      let token = localStorage.getItem("login_token");
      let headers = { "Content-Type": "application/json" };
      headers["Authorization"] = `Bearer ${token}`;

      let url = process.env.API_URL + "/users/" + id;

      fetch(url, {
        method: "DELETE",
        body: JSON.stringify({ id: id }),
        headers,
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({ fetching: false });
          if (data.deletedCount > 0) {
            history.push("/admin/profile");
          } else {
            this._addNotification(
              "Unable to delete this user, please contact Fastvet help center",
              "error",
              "Error Message: "
            );
          }
        })
        .catch((err) => {
          this.setState({ fetching: false });
          console.error(err);
        });
    }
  };
  modelClose = (e) => {
    this.setState({
      showAddNewPopup: false,
    });
  };
  modelPasswordClose = (e) => {
    this.setState({
      showUpdatePassPopup: false,
    });
  };

  filterUsers = (e) => {
    const enteredSearchTerm = e.target.value;

    if (enteredSearchTerm.length > 0 && this.state.originalUserList !== []) {
      const filteredUser = this.state.originalUserList.filter((user) => {
        if(user.fullName !== null){
          if (
            user.fullName
              .toLowerCase()
              .includes(enteredSearchTerm.toLowerCase()) ||
            user.email.toLowerCase().includes(enteredSearchTerm.toLowerCase()) ||
            user.npi.toLowerCase().includes(enteredSearchTerm.toLowerCase())
          ) {
            return true;
          }
        }
        return false;
      });
      this.setState({
        searchTerm: enteredSearchTerm,
        allUsers: filteredUser,
      });
    } else {
      this.setState((state) => ({
        searchTerm: enteredSearchTerm,
        allUsers: state.usersByPage,
      }));
    }
  };

  render() {
    const {
      fetching = false,
      error = undefined,
      getSpecificUser,
      allUsersCount = 0,
      history,
    } = this.props;
    const {
      approvalStatus = undefined,
      searchText = "",
      allUsers = [],
      selectedRoleType,
      showAddNewPopup,
      showUpdatePassPopup,
    } = this.state;

    const UserRoleType = getProperRoleName(selectedRoleType);

    return (
      <div onClick={this.closeAllPopovers}>
        {<NotificationSystem ref="notificationSystem" />}
        <Grid>
          <Row>
            <Col xs={12} style={{ paddingTop: 12.5 }}>
              <div>
                <div style={{ position: "absolute" }}>
                  <input
                    style={{ width: "40ch" }}
                    placeholder="Filter by name, email, or npi"
                    onChange={this.filterUsers}
                    value={this.state.searchTerm}
                  />
                </div>
                <h3 className="text-center">
                  {/* {UserRoleType}{'s'} */}
                  Fastvet Users
                  {/* <small className='pull-left'>
                                    Total {allUsersCount}
                                </small> */}
                  <span className="pull-right">
                    <Button
                      type="button"
                      name={"addNew"}
                      bsStyle="primary"
                      onClick={(e) => this.addNewUserModal({})}
                      // className={answer === 'No' ? "list-btn yesno-btn yesno-btn-active": "list-btn yesno-btn"}
                      className="list-btn"
                    >
                      Add New
                    </Button>
                  </span>
                </h3>
              </div>
            </Col>
          </Row>
        </Grid>
        <hr style={{ margin: 0 }} />
        <Panel horizontal>
          <PanelBody
            className="panel-sm-9 panel-xs-12"
            style={{ paddingTop: 0 }}
          >
            <Grid>
              <Row>
                <Col xs={12}>
                  <Tab.Pane eventKey={1}>
                    <Col xs={12}>
                      {/* <div className='pull-left mar-r-10'>
                                                <FormGroup
                                                    controlId='search'>
                                                    <ControlLabel>Search by Name/Email</ControlLabel>
                                                    <FormControl
                                                        type='text'
                                                        className='inline border-focus-green'
                                                        onChange={this.searchUser}
                                                        value={searchText}
                                                        placeholder='Enter name/email'/>
                                                </FormGroup>
                                            </div>
                                            <div className='pull-left mar-r-10'>
                                                <FormGroup controlId='formControlsSelect'>
                                                    <ControlLabel>Select Account Status</ControlLabel>
                                                    <FormControl
                                                        className="inline min-w-150"
                                                        componentClass='select'
                                                        value={approvalStatus}
                                                        placeholder='select'
                                                        onChange={this.selectApprovalStatus}>
                                                        <option value='undefined'>All</option>
                                                        <option value={NOT_APPROVED_USER}>
                                                            Pending
                                                        </option>
                                                        <option value={APPROVED_USER}>Approved
                                                        </option>
                                                        <option value={DENIED_USER}>Denied</option>
                                                    </FormControl>
                                                </FormGroup>
                                            </div> */}

                      <Table style={{ marginTop: 15 }} hover responsive>
                        <thead>
                          <tr>
                            <th />
                            <th>Name</th>
                            <th>Email</th>
                            {/* <th>Company Name</th> */}
                            <th>NPI</th>
                            <th>Role</th>
                            {/* <th>Created At</th> */}
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {!fetching && allUsers && allUsers.length !== 0 ? (
                            _.map(allUsers, (user) => (
                              <tr key={`${UserRoleType}-${user.id}`}>
                                {/* <td>
                                                            <img
                                                                src={user.picture && user.picture.url ? user.picture.url : DEFAULT_USER_IMAGE}
                                                                className='list-img-circle '/>
                                                        </td> */}
                                <td style={{ verticalAlign: "middle" }}></td>
                                <td style={{ verticalAlign: "middle" }}>
                                  <Button
                                    className="name-list-info"
                                    bsStyle="link"
                                    style={{ fontWeight: "bold" }}
                                    onClick={this.goToDetail}
                                  >
                                    {`${user.name.first} ${user.name.last}`}
                                  </Button>
                                </td>
                                {/* <td className={user.email ? APPROVED : PENDING}>{user.email ? user.email : ""}</td> */}
                                <td style={{ verticalAlign: "middle" }}>
                                  {user.email ? user.email : ""}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {user.npi ? user.npi : ""}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {user.role === ADMIN_ROLE
                                    ? "Doctor"
                                    : "Admin"}
                                </td>
                                {/* <td>{user.createdAt ?
                                                            moment(user.createdAt).format(DEFAULT_DATE_TIME_FORMAT)
                                                            : NOT_PROVIDED}
                                                        </td> */}
                                <td style={{ verticalAlign: "middle" }}>
                                  <div>
                                    <span
                                      style={{
                                        fontSize: "18px",
                                        fontWeight: "900",
                                        cursor: "pointer",
                                        verticalAlign: "super",
                                      }}
                                      onClick={(e) => this.showPopOver(e, user)}
                                    >
                                      ...
                                    </span>
                                    <div className="popover__wrapper">
                                      <div
                                        className={
                                          !user.popShow
                                            ? "popover__before"
                                            : "popover__after"
                                        }
                                      >
                                        <div
                                          className="popover__menu"
                                          onClick={(e) =>
                                            this.addNewUserModal(user)
                                          }
                                        >
                                          Edit
                                        </div>
                                        <div
                                          className="popover__menu"
                                          onClick={(e) =>
                                            this.updateUserPasswordModal(user)
                                          }
                                        >
                                          Reset Password
                                        </div>
                                        <div
                                          className="popover__menu"
                                          onClick={(e) =>
                                            this.deleteUser(user.id)
                                          }
                                        >
                                          Delete
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : !fetching ? (
                            <tr className="text-center fg-red">
                              <td colSpan={8}>No {selectedRoleType} found</td>
                            </tr>
                          ) : null}
                          {fetching && (
                            <tr className="text-center">
                              <td colSpan={8}>fetching...</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </Col>
                  </Tab.Pane>
                </Col>
              </Row>
            </Grid>
          </PanelBody>
        </Panel>
        {showAddNewPopup && (
          <AddNewUser
            history={history}
            onClose={(e) => this.modelClose(e)}
            user={this.state.selectedUser}
          />
        )}
        {showUpdatePassPopup && (
          <UpdateUserPassword
            history={history}
            onClose={(e) => this.modelPasswordClose(e)}
            user={this.state.selectedUser}
          />
        )}
      </div>
    );
  }
}

UserListing.propTypes = {
  getSpecificUser: PropTypes.func,
};

const mapStateToProps = ({
  user: {
    all: {
      allUsers = [],
      error = undefined,
      fetching = false,
      allUsersCount = 0,
      pageNumber = 1,
      pageSize = 10,
      filters,
    } = {},
    me: { userInfo = {} },
  },
}) => ({
  allUsers,
  filters,
  error,
  fetching,
  allUsersCount,
  userInfo,
  pageNumber
});

const mapDispatchToProps = (dispatch) => ({
  getAllUsersInfo: (selectedRoleType, pageNumber, searchText, filters) => {
    dispatch(
      UserActions.getAllUserInfoRequest(
        selectedRoleType,
        pageNumber,
        searchText,
        filters
      )
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UserListing);
